import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

const { setTrainStatusData } = slice.actions;

const getTrainStatus = (url: any) => async () => {
  try {
    const response = await API.trainStatus.getTrainStatus(url);
    dispatch(setTrainStatusData(response.data));
    return { response, status: response.status, data: response.data };
  } catch (error) {}
};

export default {
  getTrainStatus
};
